/**
 * Job Tracker Column Definitions
 */

import {
  JOB_STATUS_OPTIONS,
  PRIORITY_OPTIONS,
  DEPARTMENT_OPTIONS
} from '../../shared/constants/atsConstants';

// Re-export for backward compatibility
export { JOB_STATUS_OPTIONS, PRIORITY_OPTIONS, DEPARTMENT_OPTIONS };

export const JOB_COLUMNS = [
  {
    key: 'job_title',
    label: 'Job Title',
    type: 'text',
    required: true,
    width: 200
  },
  {
    key: 'location',
    label: 'Location',
    type: 'text',
    width: 180
  },
  {
    key: 'department',
    label: 'Department',
    type: 'select',
    options: DEPARTMENT_OPTIONS,
    width: 150
  },
  {
    key: 'sc_department',
    label: 'SC Department',
    type: 'text',
    width: 150
  },
  {
    key: 'priority',
    label: 'Priority',
    type: 'select',
    options: PRIORITY_OPTIONS,
    width: 120
  },
  {
    key: 'job_status',
    label: 'Job Status',
    type: 'select',
    options: JOB_STATUS_OPTIONS,
    width: 140
  },
  {
    key: 'recruiter',
    label: 'Recruiter',
    type: 'text',
    width: 150
  },
  {
    key: 'assigned_date',
    label: 'Assigned Date',
    type: 'datetime',
    width: 180,
    readOnly: true
  },
  {
    key: 'hiring_manager',
    label: 'Hiring Manager',
    type: 'text',
    width: 160
  },
  {
    key: 'compensation_range_from',
    label: 'Comp Range From',
    type: 'number',
    width: 150
  },
  {
    key: 'compensation_range_to',
    label: 'Comp Range To',
    type: 'number',
    width: 150
  },
  {
    key: 'allowances',
    label: 'Allowances',
    type: 'text',
    width: 200
  },
  {
    key: 'job_notes',
    label: 'Job Notes',
    type: 'textarea',
    width: 250
  },
  {
    key: 'created_at',
    label: 'Created At',
    type: 'datetime',
    width: 160,
    readOnly: true
  },
  {
    key: 'days_open',
    label: 'Days Open',
    type: 'calculated',
    width: 100,
    readOnly: true,
    calculate: (job) => {
      if (!job.created_at) return '-';
      const created = new Date(job.created_at);
      const now = new Date();
      const diffTime = Math.abs(now - created);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    }
  },
  {
    key: 'created_by',
    label: 'Created By',
    type: 'text',
    width: 150,
    readOnly: true
  }
];

// Helper function to get all column keys
export const getAllColumnKeys = () => {
  return JOB_COLUMNS.map(col => col.key);
};
